module.exports = __webpack_public_path__ + "media/thumb.aa9c48eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/templates/insta/assets/thumb.png
// module id = ./src/templates/insta/assets/thumb.png
// module chunks = 0